import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


import { AppState, Actions, store, PanelState, minDaysLater, ZapisanyFormularz } from '../../appredux'
import { connect } from 'react-redux';
import { Trans, withTranslation, WithTranslation, TransProps } from 'react-i18next';
import { Theme, withStyles } from "@material-ui/core/styles";

import { RodzPokoiInfo, ObiectRoomRodzaj, obiektService, PokojeDostepne, Result } from '../../api'

import Typography from '@material-ui/core/Typography';
import CheckIcon from '@material-ui/icons/Check';
import RemoveIcon from '@mui/icons-material/Remove';
import SearchIcon from '@mui/icons-material/Search';

import theme from '../../themes/themes';
import themeBlue from '../../themes/themesBlue';
import themeGreen from '../../themes/themesGreen';
import themeBrownLight from '../../themes/themesBrownLight';
import themeBrownDark from '../../themes/themesBrownDark';
import { WithStyles } from '@material-ui/styles';
import { datediff, daysFromDate } from '../common/helpers';
import Details from '../Details';
import { fontSelect } from '../../fonts';
import DialogError from './DialogError';
import CONFIG from '../../cfg/config';
import Loader from '../common/loader/LoaderNoWindow';
import {Room} from '../Room';
import { GRAFIK_DNI } from 'App';

const KOLOR_ZAZNACZENIA_OPISU = "#e65100"

//PM 2021-07-12
type RCalendarState = {
  selectedRoom: RodzPokoiInfo,
  openDetails: boolean,
  openError: boolean,
  dialogContent: any,
  dostepne_pokoje: boolean,
  room: Room,

  cell: ObiectRoomRodzaj,
  minDni: number,

}

//PM 2021-11-16
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface RCalendarProps extends WithStyles<typeof styles> {
  theme: string,
  zapisanyFormularz: ZapisanyFormularz,
  graphicHighlight: string,
  rooms: RodzPokoiInfo[],
  dateFromFormularz: string,
  dateTo: string,
  dateFrom: string,
  grafikRodzaje: ObiectRoomRodzaj[],
  expanded: boolean,
  windowWidth: number,
  loading: boolean,
  data: ObiectRoomRodzaj[],
  onWroc: () => Promise<void>,
  lang: string
}



class RCalendar extends React.Component<RCalendarProps & WithTranslation & TransProps, RCalendarState>  {
  textTheme = fontSelect(4, 2) as React.CSSProperties;

  primary = this.props.theme === "1" ?
    theme.palette.primary.main : this.props.theme === "2" ?
      themeBlue.palette.primary.main : this.props.theme === "3" ?
        themeBrownDark.palette.primary.main : this.props.theme === "4" ?
          themeBrownLight.palette.primary.main : themeGreen.palette.primary.main;

  constructor(props: RCalendarProps & WithTranslation & TransProps) {
    super(props, {});
    this.state = {
      selectedRoom: new RodzPokoiInfo(),
      openDetails: false,
      openError: false,
      dialogContent: [],
      dostepne_pokoje: false,
      room: {
        minIloscDni: '',
        id: '',
        rodzPokoi: '',
        pokoj: 0,
        cena: '',
        iloscMiejsc: '',
        galleryRodzPokoi: '',
        opis: '',
        info: '',
        ktoraCenaOpis: '',
      },
      cell: new ObiectRoomRodzaj(),
      minDni: 1
    }
  }

  closeError = () => {
    this.setState({openError: false})
  }

  selectRoom = (id: string) => {
    store.dispatch(
      Actions.pageState.selectRoom(PanelState.psDetails, id)
    )
  }

  //PM 2021-11-16
  //otwarcie formularza po powrocie z autoryzacji
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  async componentDidUpdate(prevProps: RCalendarProps) {
    if (this.props.zapisanyFormularz.pokoj !== '') {
      const cell = this.props.data.find(x => x.data === this.props.zapisanyFormularz.dataOd && x.rodzPokoi.trim() === this.props.zapisanyFormularz.pokoj.trim())

      if (cell)
        await this.reserve(cell)
    }
  }

  //PM 2021-11-16
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  czyHighlight(cell: ObiectRoomRodzaj) {
    return this.props.graphicHighlight === cell.rodzPokoi.trim();
  }

  //PM 2021-11-16
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  reserve = async (cell: ObiectRoomRodzaj) => {
    const t = this.props.t
    let wciecie = '  * ';
    const room = this.props.rooms.find((x: RodzPokoiInfo) => x.rodzPokoi.trim() === cell.rodzPokoi.trim())
    if (room) {
      const data = this.props.data
      const contentData = data.filter((x: ObiectRoomRodzaj) => x.typ === 3)

      let dostepnoscPokoju = contentData.filter((x: ObiectRoomRodzaj) => room.rodzPokoi.trim() === x.rodzPokoi.trim() && cell.osX <= x.osX)
      let dniMinimum: number = Number(room.minIloscDni)
      let dostepnaRezerwacja: boolean = true
      let dateTo: string = ""

       if(dostepnoscPokoju.length < dniMinimum){ //ostatnie dni grafika, sprawdzenie dostępności
         let res: Result<PokojeDostepne> = await obiektService.dajPokojeDostepne(
           {
             hotelId: CONFIG.hotelID,
             domena: this.props.lang,
             rodzPokoi:  room.rodzPokoi,
             dataOd: cell.data,
             dataDo: daysFromDate(new Date(cell.data), dniMinimum),
           }, {}
         );

         if(!res || !res.result || res.result.length <= 0){
          dostepnaRezerwacja = false
          dateTo = daysFromDate(new Date(cell.data), dniMinimum)
         }
        
       } else { //początek grafika, sprawdzenie dostępności
        for (let i = 0; i < dniMinimum; i++) {
          if(dostepnoscPokoju[i].akcjeWykonaj <= 0){
            dostepnaRezerwacja = false
          }  
        }
        dateTo = daysFromDate(new Date(cell.data), dniMinimum)
       }

      if (dostepnaRezerwacja) { //rezerwacja
        //const roznica_dni: number = datediff(new Date(this.props.dateFromFormularz), new Date(this.props.dateTo));

        //if (cell.data !== this.props.dateFrom)
          await store.dispatch(Actions.pageState.reserve1or2WithDateFromFormularz(cell.rodzPokoi.trim(), cell.data, minDaysLater(cell.data, Number(room.minIloscDni)), 0));
        //else if (roznica_dni < Number(room.minIloscDni))
        //  await store.dispatch(Actions.pageState.reserve1or2(cell.rodzPokoi.trim(), minDaysLater(this.props.dateFromFormularz, Number(room.minIloscDni)), 0));

        // AddItem(room.www_rodz_pokoi_id, room.cena_pokoj, room.ktora_cena,
        //   room.cena_os1, room.cena_os2, room.cena_os3, room.cena_os4,
        //   room.ilosc_miejsc, room.ilosc_dni_min);
      
          await store.dispatch(Actions.pageState.updateBasket(room));
        

        await store.dispatch(Actions.pageState.clearDaneNIP()); // mz 2022-06-24
        await store.dispatch(Actions.pageState.setPanelState(PanelState.psUser));


      } else { //brak miejsc  
        let dialogContent = [
          { message: t("The minimum stay is") + ": ", messageBoldPrimary: dniMinimum + " " + t("Days") },
          { message: "" },
          { message: t("In time") + ":" },
          { message: wciecie + t("Check-in") + ": ", messageBoldPrimary: cell.data },
          { message: wciecie + t("Check-out") + ": ", messageBoldPrimary: dateTo },
          { message: wciecie + t("No rooms") + ": ", messageBoldPrimary: room.opis },
        ];
        this.setState({ openError: true, dialogContent: dialogContent })
      }      
    }
  }


  //PM 2021-11-16
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  openDetails = (cell: ObiectRoomRodzaj, row: ObiectRoomRodzaj[]) => {

    const room = this.props.rooms.find((x: RodzPokoiInfo) => x.rodzPokoi.trim() === cell.rodzPokoi.trim())

    if (room) {
      let dost = row[0].akcjeWykonaj === 1
      let r =  {
        cena: room.cena,
        galleryRodzPokoi: `1-${room.rodzPokoi}`,
        id: room.id,
        iloscMiejsc: room.iloscMiejsc,
        info: room.info,
        minIloscDni: room.minIloscDni,
        opis: room.opis,
        pokoj: 0,
        rodzPokoi: room.rodzPokoi,
        ktoraCenaOpis: room.ktoraCenaOpis
      }

      this.setState({ selectedRoom: room, openDetails: true, dostepne_pokoje: dost, room: r })
    }
  }

  closeDetails = () => {
    this.setState({ openDetails: false })
  }

  setKolor = (cell: ObiectRoomRodzaj) => {
    let room = this.props.rooms.find((room) => room.rodzPokoi.trim()=== cell.rodzPokoi.trim())
    if(room){
      this.setState({cell: cell, minDni: Number(room.minIloscDni)})
    }
  }
  
  clearKolor = () => {
    this.setState({cell: new ObiectRoomRodzaj(), minDni: 1})
  }
  
  kolumnaKolor = (day: ObiectRoomRodzaj) => {
    return this.state.cell.osX <= day.osX && this.state.cell.osX + this.state.minDni > day.osX
  }
  

  //PM 2021-11-16
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  render() {
    const { classes } = this.props;

    let primary = theme.palette.primary.main
    let grafikRodzajeLenght = this.props.grafikRodzaje.filter((x: ObiectRoomRodzaj) => x.typ === 2).length

    // <Typography variant="h6" component="h2" color="primary" style={{ ...this.textTheme, padding: "20px", fontSize: "14px" }}>
    //       <b><Trans>Loading...</Trans></b>
    //     </Typography>
    if (this.props.loading)
      return (
        <Loader/>
      )
    else {


      const data = this.props.data
      let headerData = data.filter((x: ObiectRoomRodzaj) => x.typ === 1)
      const descriptionData = data.filter((x: ObiectRoomRodzaj) => x.typ === 2)
      const contentData = data.filter((x: ObiectRoomRodzaj) => x.typ === 3)

      let contentTable: ObiectRoomRodzaj[][] = []
      for (let i = 0; i < headerData.length - 1; i++) {
        contentTable.push([])
      }

      for (let i = 0; i < contentData.length / descriptionData.length; i++) {
        for (let y = 0; y < descriptionData.length; y++) {
          contentTable[i].push(contentData[i * descriptionData.length + y])
        }
      }

      const transposedContentTable = contentTable[0].map((_, colIndex) => contentTable.map(row => row[colIndex]));

      let headers: JSX.Element[] = [];

      //headerData = headerData.slice(0, this.props.page.rezerwacjeNumeryKolumny + 1)
      headerData.forEach((day: ObiectRoomRodzaj, index: number) => {
        //let headerText = day._data_opis.split(" ").join('<br>')
        const headerText = index === 0 ? ('NOCLEGI<br>') : day.dana1 + '<br>' + day.dana2;
        let dzisaj = daysFromDate(new Date, 0) === day.data //&& index === 0
        let jutro = daysFromDate(new Date, 1) === day.data //&& index === 1

        headers.push(
          <TableCell
            key={day.id}
            align="center"
            style={{
              minWidth: dzisaj ? "64px" : jutro ? "48px" : "32px", //32
              maxWidth: dzisaj ? "80px" : jutro ? "60px" : "40px", //33
              padding: "4px 0px 0px 0px", position: "sticky", top: "0",
              fontSize: "11px", lineHeight: "1rem", height: "38px", borderRight: headerData.length === index + 1 ? "0" : "1px solid rgba(224, 224, 224, 1)",
              borderBottom: "0", color: `${day.fontKolor}`, background: `${day.tloKolor}`, fontWeight: day.fontBold === 1 ? "bold" : "normal"
            }}
          >
            <div style={{ borderBottom: "1px solid rgba(170, 170, 170, 1)", height: "inherit" }}
              dangerouslySetInnerHTML={{ __html: headerText }}
            >
            </div>
          </TableCell>)
      }
      )

      let tablica: JSX.Element[][] = [];
      for (let i = 0; i < descriptionData.length; i++) {
        tablica.push([])
      }

      // let width = 0 //80 / this.props.page.rezerwacjeNumeryKolumny
      // let widthHeader = 0 //80 / this.props.page.rezerwacjeNumeryKolumny
      // const pageWidth = this.props.windowWidth > 1600 ? 1600 : this.props.windowWidth
      // if (pageWidth < 750) {
      //   width = ((pageWidth - 150 - 15 + 10) / 20) - 8
      //   widthHeader = 150 - 15
      // } else {
      //   widthHeader = (pageWidth - 14) * 0.20303 - 20
      //   width = (pageWidth - 14 - widthHeader - 20) / 20 - 8
      // }

      //console.log(transposedContentTable)
      //console.log(this.props.rooms)

      transposedContentTable.forEach((row: ObiectRoomRodzaj[], index: number) => {
        tablica[index].push(
          <TableCell
            //key={row[0].id } 
            key={`${row[0].osX}*-1`} 
            component="th" scope="row" onClick={() => this.openDetails(descriptionData[index], row)}
            className={classes.hover}
            style={{
              //minWidth: `${widthHeader}px`, maxWidth: `${widthHeader}px`, width: `${widthHeader}px`,
              //width: "20%", minWidth: "150px", 
              //width: "calc(70%/15)",
              background: this.state.cell.rodzPokoi.trim() === row[0].rodzPokoi.trim() ? "yellow" : `${descriptionData[index].tloKolor}`, padding: this.props.windowWidth <= 600 ? "0px 4px 0px 6px" : "2px 10px",
              borderRight: "1px solid rgba(224, 224, 224, 1)", borderBottom: transposedContentTable.length === index + 1 ? "0" : "1px solid rgba(224, 224, 224, 1)", cursor: 'pointer'
            }}
          >
            <Typography gutterBottom component="h6"
              className={classes.cell} style={{
                color: this.czyHighlight(row[0]) ? KOLOR_ZAZNACZENIA_OPISU : descriptionData[index].fontKolor,  //descriptionData[index].fontKolor, 
                fontWeight: descriptionData[index].fontBold === 1 ? "bold" : "normal", minWidth: this.props.windowWidth < 600 ? '133px' : "165px", minHeight: this.props.windowWidth < 600 ? "35px" : "30px",
              }}>
                <SearchIcon style={{ ...this.textTheme, width: "0.6em", color: `${this.textTheme.color}`, marginRight: "3px" }}></SearchIcon>
                {descriptionData[index].dana1}
            </Typography>
          </TableCell>
        )
        //row = row.slice(0, this.props.page.rezerwacjeNumeryKolumny)
        row.forEach((day: ObiectRoomRodzaj, i: number) => {
          //let col1 = day.tloKolor
          // if(day.data == this.props.page.dateFromCalendar){
          //   col1 = i == 0 ? descriptionData[index].tloKolor : row[i -1].tloKolor
          // }
          // if(day.data == daysFromDate(new Date(this.props.page.dateFromCalendar), this.props.page.preferences.days)){
          //   col1 = row[i -1].tloKolor
          // }
          //let tlo = this.state.cell.rodzPokoi.trim()=== day.rodzPokoi.trim() && this.kolumnaKolor(day)
          tablica[index].push(
            <TableCell
              //key={day.id}
              key={`${day.osY}*${day.osX}$`}
              //key={Math.random()}
              align="center"
              //onClick={day.akcjeWykonaj === 1 && day.pobytId > 0 ? () => this.zarzadzaj(day) : day.akcjeWykonaj === 1 ? () => this.reserve(day) : () => { }}
              onClick={day.akcjeWykonaj === 1 ? async () => await this.reserve(day) : () => { }}
              //onClick={day.akcjeWykonaj == 1  ?  () => this.reserve(day) : () => { }}
              onMouseEnter={() => this.setKolor(day)}
              onMouseLeave={() => this.clearKolor()}
              className={classes.hover}
              style={{
                background: `#${day.tloKolor}`,
                //background: tlo ? "yellow" : `#${day.tloKolor}`,
                //minWidth: "400px", maxWidth: "400px", 
                //minWidth: `${width}px`, maxWidth: `${width}px`, width: `${width}px`,
                width: `calc(70%/${GRAFIK_DNI + 1}`,
                flex: "0 0 30px",
                padding: "4px 6px 0px 6px", cursor: day.akcjeWykonaj === 1 ? "pointer" : "default",
                borderRight: row.length === i + 1 ? "0" : "1px solid rgba(224, 224, 224, 1)",
                borderBottom: transposedContentTable.length === index + 1 ? "0" : "1px solid rgba(224, 224, 224, 1)",
                fontWeight: day.fontBold === 1 ? "bold" : "normal", overflow: "hidden",
              }} >
              <span style={{ color: `${day.fontKolor}`, fontSize: "11px", overflow: "hidden", textOverflow: "clip", whiteSpace: "nowrap" }}>
                {/* {day.danePokaz === 1 ? day.dana1 : null} */}
                {day.danePokaz === 1 && day.akcjeWykonaj === 1 ? <CheckIcon color="primary" style={{ ...this.textTheme, width: "0.6em", color: `${primary}` }}></CheckIcon> :
                 <RemoveIcon color="error" style={{ ...this.textTheme, width: "0.3em" }}></RemoveIcon>}
              </span>
              {/* <div style={{display: "flex"}}>
                    <span style={{background: col1, width: "7px", padding: "21px 0px"}}  ></span>
                    <span style={{width: "calc(100% + -12px)", margin: "auto"}}>{day.iloscW < 1 ? null : <span style={{ color: `${day.fontKolor}`, fontSize: "12px" }}>{day.dana1}</span>}</span>
                    <span style={{width: "5px", padding: "21px 0px"}}></span>
                  </div>  */}
            </TableCell>
          )
        });
        // tablica[index].push(
        //   <TableCell  style={{padding: "4px"}}></TableCell>
        // )   
        // if(window.innerWidth > 600)
        //   tablica[index].push(
        //     <TableCell  style={{padding: "8px", borderBottom: "0"}}></TableCell>
        //   )       
      });

      const rows = tablica.map((row, index) => (
        <TableRow key={index}>
          {row}
        </TableRow>
      ))

      return (
        <div
          id="grafik_rodzajami"
          className={classes.root} //380px
          style={{ maxHeight: grafikRodzajeLenght <= 7 || this.props.expanded ? "1500px" : "256px", overflowX: this.props.windowWidth < 1190 ? "auto" : "hidden" }}
        >
          <Table style={{ position: "relative", borderCollapse: "collapse", borderBottom: "1px solid rgb(224, 224, 224)" }}>
            <TableHead >
              <TableRow >
                {headers}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows}
            </TableBody>
          </Table>
          {/* {this.props.page.roomsOld.length > 7 || this.props.page.rooms.length > 7 || grafikNumeryLength > 7 ?
                this.props.expanded ?
                  <KeyboardArrowUpIcon className={classes.arrow}
                    onClick={() => this.props.expand()} />
                  :
                  <KeyboardArrowDownIcon className={classes.arrow}
                    onClick={() => this.props.expand()} /> : null} */}

          <Details
            details={{
              opis: this.state.selectedRoom.opis,
              info: this.state.selectedRoom.info,
              cena: this.state.selectedRoom.cena,
              cenaZa: this.state.selectedRoom.ktoraCenaOpis,
              dniMin: this.state.selectedRoom.minIloscDni,
              osobMax: this.state.selectedRoom.iloscMiejsc,
            }}
            open={this.state.openDetails}
            close={this.closeDetails} 
            pokoje_dostepne={this.state.dostepne_pokoje}
            room={this.state.room}/>
          <DialogError open={this.state.openError} close={this.closeError} dialogContent={this.state.dialogContent}/>  
        </div>
      )
    }
  }
}

const styles = (theme: Theme) => ({
  root: {
    position: "relative" as "relative",
    overflowX: "auto" as "auto",
    maxHeight: "380px",
  },
  paper: {
    marginTop: theme.spacing(3),
    width: '100%',
    //    overflowX: 'clip',
    marginBottom: theme.spacing(2)
  },

  back: {
    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
    background: "linear-gradient(to bottom, #e49a4d, #c9823c)",
    border: "1px solid #c9823c",
    padding: "6px 8px 5px",
    lineHeight: "13px",
    fontSize: "11px",
    marginTop: "24px"
  },
  display: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "8px",
    height: "49.8px"
  },
  cell: {
    lineHeight: "14px",
    fontSize: "11px",
    //fontWeight: 600,
    //margin: "10px 0",
    minHeight: "35px",
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    marginBottom: "0px",
    fontWeight: "bold" as "bold"
  },
  hover: {
    "&:hover": {
      backgroundColor: "yellow !important"
    }
  },
  dialog: {
    maxHeight: "100%",
    maxWidth: "none",
    padding: "8px 0px 0px 16px",
  }
});

const mapStateToProps = (state: AppState) => ({
  theme: state.pageState.theme,
  zapisanyFormularz: state.pageState.zapisanyFormularz,
  graphicHighlight: state.pageState.graphicHighlight,
  rooms: state.pageState.rooms,
  dateFromFormularz: state.pageState.dateFromFormularz,
  dateTo: state.pageState.dateTo,
  dateFrom: state.pageState.dateFrom,
  grafikRodzaje: state.pageState.grafikRodzaje,
  lang: state.pageState.lang
});

export default withStyles(styles)(connect(mapStateToProps)(withTranslation()(RCalendar)));
